<div>
  <app-group-header
    [label]="group.label"
    [groupId]="group.id"
    (findInChat)="onFindInChat()">
  </app-group-header>
  <app-group-content>
    <app-creative-card-grid slot="content" [cards]="group.cards"></app-creative-card-grid>
  </app-group-content>
</div>
